/* Mobellia — motion (built by ovanap.dev team).
 * Quiet-luxury scroll motion: hero + split-banner parallax and soft
 * scroll-into-view reveals. transform/opacity only, rAF-throttled, GPU-safe.
 * Fully disabled for prefers-reduced-motion. Re-inits on shopify:section:load.
 */
(function () {
  var mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if (mql && mql.matches) return; // respect reduced motion — no class, no motion

  document.documentElement.classList.add('js-motion');

  /* ---------- Scroll reveals ---------- */
  var REVEAL_SEL = [
    '[data-reveal]',
    '.m-tilegrid__head', '.m-carousel__head', '.m-insta__head', '.m-reviews__head',
    '.m-page__head', '.m-contact__head', '.m-faq__head',
    '.m-tile', '.m-card', '.m-review', '.m-insta__cell', '.m-trust__item',
    '.m-split__panel', '.m-acc__item'
  ].join(',');

  var io = null;
  var parentCount = new WeakMap();

  function ensureObserver() {
    if (io || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function setupReveals(scope) {
    var els = (scope || document).querySelectorAll(REVEAL_SEL);
    if (!('IntersectionObserver' in window)) {
      // No IO support: just show everything.
      for (var i = 0; i < els.length; i++) els[i].classList.add('m-reveal', 'is-in');
      return;
    }
    ensureObserver();
    els.forEach(function (el) {
      if (el.__mReveal) return;
      el.__mReveal = true;
      el.classList.add('m-reveal');
      // Gentle per-parent stagger (first item no delay, capped).
      var n = parentCount.get(el.parentNode) || 0;
      parentCount.set(el.parentNode, n + 1);
      if (n > 0) el.style.transitionDelay = (Math.min(n, 6) * 0.055).toFixed(3) + 's';
      io.observe(el);
    });
  }

  /* ---------- Parallax (hero + split-banner) ---------- */
  var hero = null, splitImgs = [];

  function collectParallax() {
    hero = document.querySelector('.m-hero');
    splitImgs = Array.prototype.slice.call(document.querySelectorAll('.m-split__img'));
  }

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Hero: image drifts down slightly as the hero scrolls out of view.
      if (hero) {
        var img = hero.querySelector('.m-hero__img');
        if (img) {
          var hr = hero.getBoundingClientRect();
          var prog = clamp(-hr.top / (hero.offsetHeight || vh), 0, 1);
          var shift = prog * (hero.offsetHeight * 0.06); // within the 7% oversize margin
          img.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
        }
      }

      // Split-banner: subtle depth based on each image's position in the viewport.
      for (var i = 0; i < splitImgs.length; i++) {
        var im = splitImgs[i];
        var r = im.getBoundingClientRect();
        var centre = r.top + r.height / 2;
        var p = clamp((centre - vh / 2) / vh, -1, 1); // -1..1 around viewport centre
        var y = p * (r.height * 0.05); // ±5%, inside the 7% margin
        im.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      }

      ticking = false;
    });
  }

  function start() {
    setupReveals(document);
    collectParallax();
    if (hero || splitImgs.length) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: re-init for the (re)loaded section.
  document.addEventListener('shopify:section:load', function (e) {
    setupReveals(e.target);
    collectParallax();
    onScroll();
  });
})();
